import React from 'react';
import { MessagesSquare, FileText, Plane, Stethoscope, ShieldCheck } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

export default function ProcessSection() {
  const { t } = useLanguage();
  const steps = [
    { Icon: MessagesSquare, key: 'step1' },
    { Icon: FileText, key: 'step2' },
    { Icon: Plane, key: 'step3' },
    { Icon: Stethoscope, key: 'step4' },
    { Icon: ShieldCheck, key: 'step5' },
  ];

  return (
    <section id="process" className="section-padding section-tone-d">
      <div className="container-premium">
        <div className="section-head">
          <span className="section-eyebrow">{t('process.eyebrow', 'How it works')}</span>
          <h2 className="section-title">{t('process.title', 'Your Journey to a New Smile')}</h2>
          <p className="section-sub">
            {t('process.subtitle', 'Simple, transparent and stress-free — from your first message to your final follow-up.')}
          </p>
        </div>

        <ol className="process-timeline">
          {steps.map(({ Icon, key }, idx) => (
            <li key={key} className="process-step">
              <div className="process-num">{String(idx + 1).padStart(2, '0')}</div>
              <div className="process-icon">
                <Icon size={20} />
              </div>
              <div className="process-body">
                <h3>{t(`process.${key}.title`, '')}</h3>
                <p>{t(`process.${key}.description`, '')}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
